<template>
    <div class="login-page" v-bind:style="{ backgroundImage: 'url(' + bgImage + ')' }">
      <div class="form-login">
        <div class="col-md-4 ml-auto">
          <!-- Middle Box -->
          <div class="middle-box">
            <div class="card">
                <div class="card-body p-4" style="margin-top: 200px;">
                    <!-- Logo -->
                    <div class="card-body-login mb-30 text-left">
                      <!-- <img src="http://demo.riktheme.com/zinox/side-menu-full-2/img/core-img/logo.png" alt=""> -->
                      <!-- <img class="desktop-logo mx-auto" :src="`${publicPath}asset/img/BRP-Logo.png`" alt="Desktop Logo"> -->
                      <span style="color: white; font-weight: bold; font-size: 25px"><b><i>{{ companyName }}</i></b></span>
                    </div>

                    <!-- <h4 class="font-18">{{ company }}</h4> -->
                    <p class="text-muted mb-1">Sign in to continue.</p>

                    <form action="#">
                        <div class="form-group">
                            <label class="float-left" for="emailaddress">Username</label>
                            <input class="form-control" type="email" id="emailaddress" required="" placeholder="Enter username" v-model="login.username" >
                        </div>

                        <div class="form-group">
                            <label class="float-left" for="password">Password</label>
                            <input class="form-control" type="password" required="" id="password" placeholder="Enter your password" v-model="login.password">
                        </div>

                        <!-- <div class="form-group mb-3">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="checkbox-signin" checked="">
                                <label class="custom-control-label" for="checkbox-signin">Remember me</label>
                            </div>
                        </div> -->

                        <div class="form-group mb-0 text-center">
                            <button class="btn btn-primary btn-block btn-login" type="button" @click="handleLoginFormSubmit()" v-show="signIn">Sign In</button>
                            <button class="btn btn-primary btn-block btn-login" type="button" disabled v-show="submitLoading">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                            </button>
                            <p class="text-light mt-5 text-left" v-html="errorMessage"></p>
                        </div>

                    </form>
                </div> <!-- end card-body -->
            </div>
            <!-- end card -->
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import axios from 'axios'
// import { loginUrl, userTokenUrl, getHeader } from './../config'
import { getHeader, loginUrl, userTokenUrl, companyNo, companyStartUrl } from './../config'
import { companyName } from './../env'
export default {
  data () {
    return {
      publicPath: process.env.BASE_URL,
      company: companyName,
      login: {
        username: null,
        email: null,
        password: null
      },
      submitLoading: false,
      signIn: true,
      errorMessage: null,
      bgImage: '/asset/img/login-bg.jpg',
      companyName: 'Prisma'
    }
  },
  created () {
    this.getCompanyConfig()
    if (window.localStorage.getItem('authUser')) {
      this.$router.push({ name: 'home' })
    }
  },
  methods: {
    async getCompanyConfig () {
      var data = {
        company_no: companyNo
      }
      console.log(data)
      console.log(companyStartUrl)
      await axios.post(companyStartUrl, data)
        .then(response => {
          console.log(response.data.data.name)
          var res = response.data.data.photos.find(d => d.tag === 'background')
          if (res) {
            this.bgImage = res.url
          }
          this.companyName = response.data.data.name
          console.log(res.url)
        })
        .catch(error => {
          console.log(error.response)
        })
    },
    async handleLoginFormSubmit () {
      console.log('login url: ' + loginUrl)
      this.submitLoading = true
      this.signIn = false
      const postData = {
        username: this.login.username,
        password: this.login.password
      }
      const authUser = {}
      await axios.post(loginUrl, postData)
        .then(response => {
          authUser.token = response.data.token
          window.localStorage.setItem('authUser', JSON.stringify(authUser))
          axios.get(userTokenUrl, { headers: getHeader() })
            .then(response => {
              authUser.permissions = response.data.data.permissions
              authUser.user = response.data.data
              window.localStorage.setItem('authUser', JSON.stringify(authUser))
              this.$store.dispatch('setUserObject', response.data.data)
              this.$store.commit('SET_CURRENT_MENU', 'dashboard')
              this.$router.push({ name: 'home' })
              window.reload()
            })
            .catch(error => {
              console.log(error)
              console.log(error.response)
            })
          this.submitLoading = false
          this.signIn = true
        })
        .catch(error => {
          this.submitLoading = false
          this.signIn = true
          this.errorMessage = error.response.data.message
        })
    }
  }
}
</script>

<style>
.login-page {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 999;
}
.middle-box {
    height: 100vh;
    background-color: #1A1A2E;
    color: #FFFFFF;
}
.middle-box .card {
    background-color: #1A1A2E;
    color: #ffffffff;
}
.middle-box h4 {
    color: #000;
    font-weight: bold;
}
.btn-login{
    background-color: #7FCD91;
    border: 0;
}
.btn-login:hover,
.btn-login:disabled{
    background-color: #3a9b51;
    color: #fff;
}
.desktop-logo {
  width: 100px;
  height: 100px;
}
</style>
